import ChatAudioRecorder from "./ChatAudioRecorder";

export default ChatAudioRecorder;
